import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import "./MyFleetBreadcrumb.scss";

import { Button, Icon } from "abs-ui-components";

import ImportVessel from "../ImportVessel/ImportVessel";
import AbsModal from "../../common/absModal/AbsModal";
import BreadCrumb from "../../common/breadCrumb/BreadCrumb";

const baseURL = process.env.REACT_APP_BASE_URL;

export const MyFleetBreadcrumb = ({
	refetchVesselList,
	handleExportTableOnClick,
	exportFleetEnabled,
}) => {
	const navigate = useNavigate();

	const [isImportVesselModalOpen, setIsImportVesselModalOpen] =
		useState(false);

	const toggleImportVessel = (success) => {
		setIsImportVesselModalOpen(!isImportVesselModalOpen);
		if (success) {
			refetchVesselList();
		}
	};

	const breadcrumb = useMemo(
		() => [{ label: "My Fleet", url: "", navId: "myfleet_navId" }],
		[]
	);

	return (
		<>
			<div className="my-fleet-actions-container">
				<BreadCrumb items={breadcrumb} />
				<div className="actions-buttons-right">
					<div className="enroll-import-buttons">
						<Button
							startIcon={<Icon icon={"add"} />}
							className="icon-gap"
							onClick={() => {
								navigate("enroll-vessel");
							}}
						>
							Enroll Vessel
						</Button>

						<Button
							startIcon={<Icon icon={"exit_to_app"} />}
							className="icon-gap"
							onClick={toggleImportVessel}
						>
							Import Vessels
						</Button>
					</div>
					<Button
						disabled={!exportFleetEnabled}
						startIcon={<Icon icon="ios_share" />}
						onClick={handleExportTableOnClick}
						variant="secondary"
						className=""
					>
						{exportFleetEnabled
							? "Export Vessels"
							: "Please wait..."}
					</Button>
				</div>
			</div>
			<div className="confirmation-modal-container">
				{isImportVesselModalOpen && (
					<AbsModal
						isOpen={isImportVesselModalOpen}
						title="Import Vessel(s) "
						onClose={setIsImportVesselModalOpen}
						close={toggleImportVessel}
					>
						<ImportVessel cancelImportVessel={toggleImportVessel} />
					</AbsModal>
				)}
			</div>
		</>
	);
};
